<template>
  <li class="search-result search-address-result" v-if="this.$props.resultData.type == 'Vej' || this.$props.resultData.type == 'Adresse'" @click="goToStreet($event);" aria-label="Vis rute til adressen">
    <span class="float-left">
      {{ resultData.name }}
    </span>
    <span class="float-right">
      <span class="small-text"><em>{{ type }}</em></span>
    </span>
  </li>
  <li class="search-result" v-else>
    <router-link :to="{path: linkValue}">
      <span class="float-left">
        {{ resultData.name }}
      </span>
      <span class="float-right">
        <span class="small-text"><em>{{ type }}</em></span>
      </span>
    </router-link>
  </li>
</template>

<script>

export default {
  data() {
    return {
      linkValue: '/',
      type: ''
    }
  },
  props: {
    resultData: {
      type: Object,
      required: true
    },
    tagList: {
      type: Object,
      required: true
    }
  },
  created() {
    this.createData();
  },
  updated() {
    this.createData();
  },
  methods: {
    createData() {
      if(this.$props.resultData.type != 'Vej' && this.$props.resultData.type != 'Adresse') {
        this.linkValue = '/tag/'+this.$props.resultData.tagId+'/place/'+(this.$props.resultData.placeId || this.$props.resultData.id);
      }
      this.type = ((this.$props.resultData.comune) ? this.$props.resultData.code+", "+this.$props.resultData.comune : (this.$props.resultData.type == "item") ? this.tagList[parseInt(this.$props.resultData.tagId)].name : this.$props.resultData.type);
    },
    goToStreet(e) {
      var url = encodeURI(this.resultData.href);
      var xhttp = new XMLHttpRequest();
      var that = this;

  	  xhttp.onreadystatechange = function() {
  	    if (this.readyState == 4 && this.status == 200) {
  				var data = JSON.parse(this.response);
          if(data.length) {
            var directionsUrl = 'directions/coords/'+data[0].adgangspunkt.koordinater[1]+','+data[0].adgangspunkt.koordinater[0];
          }
          else {
            var directionsUrl = 'directions/coords/'+data.adgangspunkt.koordinater[1]+','+data.adgangspunkt.koordinater[0];
          }
          
          that.goToUrl(directionsUrl);
  	    }
  	  };
  	  xhttp.open("GET", url, false);
  	  xhttp.send();
    },

    goToUrl(directionsUrl) {
      this.$router.push({path: directionsUrl});
    }
  }
}
</script>

<style lang="scss" scoped>
  .search-address-result {
    color: #00708d;
  }

  .search-address-result span {
    pointer-events: none;
  }

  .search-result {
  	border-bottom: 1px solid rgba(190, 190, 190, 0.5);
  	line-height: 40px;
    min-height: 40px;
    vertical-align: middle;
  	padding: 0px 5px;
  	clear: both;
  	display: inline-block;
  	width: 100%;
    cursor: pointer;
  }

  @media screen and (min-width: 767px) {
  	.search-result {
  		padding: 0px;
  	}
  }

  .long-search-result {
  	max-width: 45%;
    line-height: 23px;
  	padding-top: 10px;
    padding-bottom: 10px;
  }

  .long-search-result:first-child {
  	max-width: 55%;
    min-height: 50px;
  }
</style>
